import { css } from 'styled-components';

const fontSize = css `
  font-size: ${props => props.$fontSize};
`;

export { fontSize };
//# sourceMappingURL=fontSize.js.map
